module.exports = __webpack_public_path__ + "static/designhub-cover-02594ea2e9b824b0b6f2c5a43dff26ad.png";